import MomentUtils from "@date-io/moment";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import Axios from "axios";
import { useFormik } from "formik";
import React, { useContext, useState } from "react";
import { Form } from "react-bootstrap";
import { FillContext } from "../../../../../../../../hooks/ContextStore";
import ActionButton from "../../../../../../../modules/CustomizeComponent/ActionButton";


export default function CreateMineralInterest(props) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const {setInterests, client_case_id } = props;
  const [marketValueDate, setMarketValueDate] = useState(new Date());
  const [fill,setFill] = useContext(FillContext);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit = async (values) => {
    const formObj = {
      client_case_id: client_case_id ? client_case_id : null,
      value_date: marketValueDate,
      values,
    };

    setLoading(true);
    const response = await Axios.post(
      "api/estate/mineral/interest",
      formObj
    ).catch((err) => {
      if (err && err.response) console.log("Error", err);
    });

    if (response) {
      setOpen(false);
      setInterests(response.data.data);
      setFill({ ...fill, mineral_interest: 1 });
      formik.resetForm();
      setTimeout(() => {
        setLoading(false);
      }, 1500);
    }
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      type: "",
      address: "",
      legal_description: "",
      producer: "",
      value: 0,
      other_liens: 0,
      client_sp: 0,
      spouse_sp: 0,
      notes: "",
      cost: 0,
      mortgage: 0,
      to_client: 0,
    },
    validateOnBlur: true,
    onSubmit,
  });

  const handleMarketValueDateChange = (date) => {
    let date_dt = new Date(date);
    let new_date = new Date(
      date_dt.getFullYear(),
      date_dt.getMonth(),
      date_dt.getDate(),
      "10",
      "56",
      "00"
    );

    setMarketValueDate(new_date);
  };

  return (
    <>
      <ActionButton
        type="button"
        className="btn btn-primary ml-auto"
        onClick={handleClickOpen}
      >
        Add
      </ActionButton>
      <Dialog
        fullWidth={true}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Mineral Interest"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div className="login-form login-signin" id="kt_login_signin_form">
              <form
                onSubmit={formik.handleSubmit}
                className="form fv-plugins-bootstrap fv-plugins-framework"
              >
                <div className="form-group fv-plugins-icon-container">
                  <Form.Label>Name of mineral interest/lease/well</Form.Label>
                  <input
                    type="text"
                    name="name"
                    className={`form-control form-control-solid h-auto py-5 px-6 `}
                    onChange={formik.handleChange}
                    onblur={formik.handleBlur}
                    value={formik.values.name}
                  />
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.name ? formik.errors.name : ""}
                    </div>
                  </div>
                </div>

                <div className="form-group fv-plugins-icon-container">
                  <Form.Label>Type of Interest</Form.Label>
                  <input
                    type="text"
                    className={`form-control form-control-solid h-auto py-5 px-6 `}
                    name="type"
                    onChange={formik.handleChange}
                    onblur={formik.handleBlur}
                    value={formik.values.type}
                  />
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.type ? formik.errors.type : ""}
                    </div>
                  </div>
                </div>

                <div className="form-group fv-plugins-icon-container">
                  <Form.Label>State and County of Location</Form.Label>
                  <input
                    type="text"
                    className={`form-control form-control-solid h-auto py-5 px-6 `}
                    name="address"
                    onChange={formik.handleChange}
                    onblur={formik.handleBlur}
                    value={formik.values.address}
                  />
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.address ? formik.errors.address : ""}
                    </div>
                  </div>
                </div>
                <div className="form-group fv-plugins-icon-container">
                  <Form.Label>Name of producer/operator</Form.Label>
                  <input
                    type="text"
                    className={`form-control form-control-solid h-auto py-5 px-6 `}
                    name="producer"
                    onChange={formik.handleChange}
                    onblur={formik.handleBlur}
                    value={formik.values.producer}
                  />
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.producer ? formik.errors.producer : ""}
                    </div>
                  </div>
                </div>
                <div className="form-group fv-plugins-icon-container">
                  <Form.Label>Current value as of</Form.Label>
                  <MuiPickersUtilsProvider
                    utils={MomentUtils}
                  >
                    <KeyboardDatePicker
                      disableToolbar
                      variant="inline"
                      format="MM/DD/yyyy"
                      margin="normal"
                      id="date-picker-inline"
                      value={marketValueDate}
                      onChange={handleMarketValueDateChange}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                    />
                  </MuiPickersUtilsProvider>
                  <Form.Label>Current Value</Form.Label>
                  <input
                    type="number"
                    className={`form-control form-control-solid h-auto py-5 px-6 `}
                    name="value"
                    onChange={formik.handleChange}
                    onblur={formik.handleBlur}
                    value={formik.values.value}
                  />
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.value ? formik.errors.value : ""}
                    </div>
                  </div>
                </div>
                <div className="form-group fv-plugins-icon-container">
                  <Form.Label>Liens against property</Form.Label>
                  <input
                    type="number"
                    className={`form-control form-control-solid h-auto py-5 px-6 `}
                    name="other_liens"
                    onChange={formik.handleChange}
                    onblur={formik.handleBlur}
                    value={formik.values.other_liens}
                  />
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.other_liens
                        ? formik.errors.other_liens
                        : ""}
                    </div>
                  </div>
                </div>
                <div className="form-group fv-plugins-icon-container">
                  <Form.Label>Client’s separate property</Form.Label>
                  <input
                    type="number"
                    className={`form-control form-control-solid h-auto py-5 px-6 `}
                    name="client_sp"
                    onChange={formik.handleChange}
                    onblur={formik.handleBlur}
                    value={formik.values.client_sp}
                  />
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.client_sp ? formik.errors.client_sp : ""}
                    </div>
                  </div>
                </div>
                <div className="form-group fv-plugins-icon-container">
                  <Form.Label>Spouse’s separate property</Form.Label>
                  <input
                    type="number"
                    className={`form-control form-control-solid h-auto py-5 px-6 `}
                    name="spouse_sp"
                    onChange={formik.handleChange}
                    onblur={formik.handleBlur}
                    value={formik.values.spouse_sp}
                  />
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.spouse_sp ? formik.errors.spouse_sp : ""}
                    </div>
                  </div>
                </div>
                <div className="form-group fv-plugins-icon-container">
                  <Form.Label>Notes</Form.Label>
                  <input
                    type="text"
                    className={`form-control form-control-solid h-auto py-5 px-6 `}
                    name="notes"
                    onChange={formik.handleChange}
                    onblur={formik.handleBlur}
                    value={formik.values.notes}
                  />
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.notes ? formik.errors.notes : ""}
                    </div>
                  </div>
                </div>
                <div className="form-group d-flex flex-wrap justify-content-between align-items-center">
                  <ActionButton
                    id="kt_login_signin_submit"
                    type="submit"
                    disabled={loading}
                    className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
                  >
                    <span>Submit</span>
                    {loading && (
                      <span className="ml-3 spinner spinner-white"></span>
                    )}
                  </ActionButton>
                </div>
              </form>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
}
